import React, { useState } from "react";
import { Button, Modal, Upload, Select, Table } from "antd";
import Papa from "papaparse";
import isEmpty from "lodash/isEmpty";
const { Option } = Select;

const FIELDS = [
  { label: "Name", value: "name" },
  { label: "SKU", value: "sku" },
  { label: "Quantity", value: "qty" }
];

const CSVUpload = ({ onClose, onSubmit }) => {
  const [file, setFile] = useState();
  const [headers, setHeaders] = useState();
  const [mappings, setMappings] = useState({});
  const [showMapping, setShowMapping] = useState(false);
  const [data, setData] = useState();

  const handleOk = () => {
    onSubmit(data);
  };

  const onFileSelect = file => {
    setFile(file);
    Papa.parse(file, {
      header: false,
      preview: 1,
      skipEmptyLines: true,
      complete: result => {
        const csvLines = result.data[0];
        if (csvLines) {
          setHeaders(csvLines);
          setShowMapping(true);
        }
      }
    });
  };

  const changeMapping = (name, value) => {
    mappings[name] = value;
    setMappings({ ...mappings });
  };

  const onProcess = () => {
    const rows = [];
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      step: (results, parser) => {
        const data = {};
        Object.keys(mappings).forEach(key => {
          const val = results.data[key];
          const mappedKey = mappings[key];
          if (mappedKey) {
            data[mappedKey] = val;
          }
        });
        rows.push(data);
      },
      complete: () => {
        onSubmit(rows, file);
      }
    });
  };

  return (
    <Modal
      title="Upload CSV"
      visible
      onOk={handleOk}
      onCancel={onClose}
      footer={null}
    >
       {!file ? (
        <Upload
          accept=".csv"
          beforeUpload={onFileSelect}
          onRemove={() => setFile()}
        >
          <Button ghost icon="upload" size="large" type="primary">
            Select CSV File
          </Button>
        </Upload>
      ) : showMapping ? (
        <div>
          <h4>Field Mapping</h4>
          <p>
            Using the columns from the first row, select the matching fields.
            Each field should only be used once. You can use the SKU or the Name field or both, though we recommend the SKU only. Fields must match exactly.
          </p>
          <table className="table" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>CSV Column Names</th>
                <th>Target Fields in Mappings</th>
              </tr>
            </thead>
            <tbody>
              {headers.map(col => {
                const selected = mappings[col];
                return (
                  <tr key={col}>
                    <td>{col}</td>
                    <td>
                      <Select
                        placeholder="Select"
                        style={{ width: 150 }}
                        value={selected}
                        onChange={val => changeMapping(col, val)}
                      >
                        <Option value="">Select</Option>
                        {FIELDS.map(f => (
                          <Option
                            key={f.value}
                            disabled={
                              f.value !== selected &&
                              Object.values(mappings).includes(f.value)
                            }
                            value={f.value}
                          >
                            {f.label}
                          </Option>
                        ))}
                      </Select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <br />
          <Button
            size="large"
            disabled={isEmpty(mappings)}
            type="primary"
            onClick={onProcess}
          >
            Next
          </Button>
        </div>
      ) : (
        <div />
      )}
    </Modal>
  );
};

export default CSVUpload;
